import { NavLink, useLocation } from 'react-router-dom'
import { Home, Info, HelpCircle, FileText } from 'lucide-react'
import { SIDEBAR_SECTIONS } from '@/lib/config'
import { cn } from '@/lib/utils'

export default function Sidebar() {
  const location = useLocation()

  return (
    <aside className="w-60 shrink-0 h-full bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-700 flex flex-col overflow-y-auto">
      <nav className="flex-1 py-3">
        {/* Dashboard */}
        <div className="px-3 mb-1">
          <NavLink
            to="/app/dashboard"
            className={({ isActive }) => cn(
              'flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
              isActive
                ? 'bg-cerah-teal-light text-cerah-teal'
                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
            )}
          >
            <Home size={16} />
            Dashboard
          </NavLink>
        </div>

        {/* Sections */}
        {SIDEBAR_SECTIONS.map(section => (
          <div key={section.title} className="mt-4">
            <p className="px-6 mb-1 text-[10px] font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wider">
              {section.title}
            </p>
            {section.grid ? (
              <div className="px-3 grid grid-cols-2 gap-1">
                {section.items.map(item => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) => cn(
                      'flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-medium transition-colors',
                      isActive
                        ? 'bg-cerah-teal-light text-cerah-teal'
                        : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'
                    )}
                  >
                    <FileText size={12} />
                    {item.label}
                  </NavLink>
                ))}
              </div>
            ) : (
              <div className="px-3 flex flex-col gap-0.5">
                {section.items.map(item => {
                  const isActive = location.pathname === item.path
                  return (
                    <NavLink
                      key={item.path}
                      to={item.path}
                      className={cn(
                        'flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs transition-colors',
                        isActive
                          ? 'bg-cerah-teal-light text-cerah-teal font-medium'
                          : 'text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800'
                      )}
                    >
                      <FileText size={12} className="shrink-0" />
                      <span className="truncate">{item.label}</span>
                    </NavLink>
                  )
                })}
              </div>
            )}
          </div>
        ))}
      </nav>

      {/* Bottom links */}
      <div className="border-t border-gray-100 dark:border-gray-800 p-3 flex flex-col gap-0.5">
        <NavLink
          to="/app/tentang"
          className={({ isActive }) => cn(
            'flex items-center gap-2 px-3 py-2 rounded-lg text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800',
            isActive && 'bg-cerah-teal-light text-cerah-teal'
          )}
        >
          <Info size={14} /> Tentang CERAH Pedia
        </NavLink>
        <NavLink
          to="/app/bantuan"
          className={({ isActive }) => cn(
            'flex items-center gap-2 px-3 py-2 rounded-lg text-xs text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-800',
            isActive && 'bg-cerah-teal-light text-cerah-teal'
          )}
        >
          <HelpCircle size={14} /> Bantuan & FAQ
        </NavLink>
      </div>
    </aside>
  )
}
